import type { JobStatus } from "./types";

export function statusLabel(status: JobStatus): string {
  return (
    {
      queued: "排队中",
      submitted_to_provider: "生成中",
      completed: "已完成",
      failed: "失败",
      cancelled: "已取消",
    } as Record<JobStatus, string>
  )[status] ?? status;
}

export function statusVariant(status: JobStatus): "success" | "warning" | "destructive" | "default" {
  if (status === "completed") return "success";
  if (status === "failed" || status === "cancelled") return "destructive";
  if (status === "queued" || status === "submitted_to_provider") return "warning";
  return "default";
}

// Single source of truth for "the task is still working" — keeps the empty-
// state copy, auto-refresh polling, and progress-bar visibility in sync.
export function isJobInFlight(status: JobStatus): boolean {
  return status === "queued" || status === "submitted_to_provider";
}

export function jobTypeLabel(jobType: string): string {
  return (
    {
      free_image_generation: "自由创作",
      fashion_model_generation: "服装模特",
      product_scene_generation: "商品场景",
    } as Record<string, string>
  )[jobType] ?? jobType;
}

export function assetTypeLabel(t: string): string {
  return (
    {
      source_product_image: "原图",
      generated_image: "结果图",
      model_reference: "模特参考",
      scene_reference: "场景参考",
    } as Record<string, string>
  )[t] ?? t;
}

export function transactionLabel(type: string): string {
  return (
    {
      topup: "充值",
      charge: "充值",
      consume: "消费",
      generation_charge: "消费",
      refund: "退费",
      adjustment: "调整",
      admin_adjust: "调整",
    } as Record<string, string>
  )[type] ?? type;
}

export function formatTime(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const today = new Date();
  const sameDay =
    d.getFullYear() === today.getFullYear() &&
    d.getMonth() === today.getMonth() &&
    d.getDate() === today.getDate();
  if (sameDay) {
    return d.toLocaleTimeString("zh-CN", { hour: "2-digit", minute: "2-digit" });
  }
  return d.toLocaleDateString("zh-CN", {
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}
